module.exports = __webpack_public_path__ + "static/img/lx_t.70e585f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lx_t.png
// module id = P8wx
// module chunks = 1